module.exports = __webpack_public_path__ + "img/hk.5698248d.png";